import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedWarningIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V10Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2476 4.18624C11.0074 2.80469 12.9926 2.80469 13.7524 4.18624L21.3699 18.0362C22.103 19.3691 21.1387 21 19.6175 21H4.38254C2.86134 21 1.89701 19.3691 2.63011 18.0362L10.2476 4.18624Z",
			stroke: "#333333",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedWarningIcon);
const Memo = memo(ForwardRef);
export default Memo;
